import { render, staticRenderFns } from "./booking.vue?vue&type=template&id=38d55602&scoped=true&"
import script from "./booking.vue?vue&type=script&lang=js&"
export * from "./booking.vue?vue&type=script&lang=js&"
import style0 from "./booking.vue?vue&type=style&index=0&id=38d55602&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d55602",
  null
  
)

export default component.exports